import { render, staticRenderFns } from "./OrganizationDocumentsNew.vue?vue&type=template&id=fc9390a0&scoped=true&"
import script from "./OrganizationDocumentsNew.vue?vue&type=script&lang=js&"
export * from "./OrganizationDocumentsNew.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDocumentsNew.vue?vue&type=style&index=0&id=fc9390a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9390a0",
  null
  
)

export default component.exports